var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('tab-bar'),_c('div',{staticClass:"wrapper"},[_c('menu-left',{staticClass:"manual-left"}),_c('div',{staticClass:"menu-right"},[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }